import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { ExportTypeEnum } from '../enums/export-type.enum';
import { ExportStatusEnum } from '../enums/export-status.enum';
import { S3FileLocationInterface } from '../interfaces/s3-file-location.interface';
import { property } from '@pristine-ts/metadata';

@dynamicTableName('EXPORT_TABLE_NAME')
export class ExportModel {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  organizationId: string;
  @attribute()
  @property()
  calculationId: string;
  @attribute()
  @property()
  calculationTitle: string;
  @attribute()
  @property()
  exportType: ExportTypeEnum;
  @attribute()
  @property()
  status: ExportStatusEnum;
  @attribute()
  @property()
  fileLocation?: S3FileLocationInterface;
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
}
